/**
 * Extended Article – auto table of contents from headings
 */
(function () {
  'use strict';

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function getScrollOffset(root) {
    const settingOffset = parseInt(root.dataset.tocScrollOffset, 10);
    if (!Number.isNaN(settingOffset) && settingOffset > 0) {
      return settingOffset;
    }

    const stickyHeader = document.querySelector(
      '.shopify-section-header-sticky, .header--sticky, .js-header-sticky, header.site-header'
    );
    if (stickyHeader) {
      return stickyHeader.getBoundingClientRect().height + 24;
    }

    return 120;
  }

  function scrollToHeading(heading, root) {
    const offset = getScrollOffset(root);
    const top = heading.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function uniqueId(base, used) {
    let id = base || 'section';
    let count = 1;
    while (used.has(id)) {
      id = `${base}-${count}`;
      count += 1;
    }
    used.add(id);
    return id;
  }

  function buildToc(root) {
    const content = root.querySelector('[data-eaa-content]');
    const list = root.querySelector('[data-eaa-toc-list]');
    const empty = root.querySelector('[data-eaa-toc-empty]');
    if (!content || !list) return;

    const selector = root.dataset.tocHeadings || 'h2,h3';
    const headings = content.querySelectorAll(selector);
    list.innerHTML = '';

    if (!headings.length) {
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    const usedIds = new Set();

    headings.forEach((heading) => {
      const text = heading.textContent.trim();
      if (!text) return;

      const baseId = slugify(text);
      const id = uniqueId(baseId, usedIds);
      heading.id = id;
      heading.style.scrollMarginTop = `${getScrollOffset(root)}px`;

      const li = document.createElement('li');
      li.className = 'eaa__toc-item';

      const link = document.createElement('a');
      link.href = `#${id}`;
      link.className = 'eaa__toc-link';
      if (heading.tagName.toLowerCase() === 'h3') {
        link.classList.add('eaa__toc-link--child');
      }
      link.textContent = text;
      link.setAttribute('data-eaa-toc-link', '');

      link.addEventListener('click', (event) => {
        event.preventDefault();
        scrollToHeading(heading, root);
        history.replaceState(null, '', `#${id}`);
        setActiveLink(root, link);
      });

      li.appendChild(link);
      list.appendChild(li);
    });

    initScrollSpy(root);
  }

  function setActiveLink(root, activeLink) {
    root.querySelectorAll('[data-eaa-toc-link]').forEach((link) => {
      link.classList.toggle('is-active', link === activeLink);
    });
  }

  // function initFixedSidebarToc(root) {
  //   const sidebar = root.querySelector('.eaa__sidebar');
  //   const toc = root.querySelector('.eaa__toc');
  //   const body = root.querySelector('.eaa__body');
  //   if (!sidebar || !toc || !body) return;

  //   const mq = window.matchMedia('(min-width: 990px)');
  //   let placeholder = null;

  //   function resetTocPosition() {
  //     toc.classList.remove('is-fixed');
  //     toc.style.position = '';
  //     toc.style.top = '';
  //     toc.style.left = '';
  //     toc.style.width = '';
  //     toc.style.bottom = '';
  //     toc.style.maxHeight = '';
  //     if (placeholder && placeholder.parentNode) {
  //       placeholder.remove();
  //       placeholder = null;
  //     }
  //   }

  //   function updateTocPosition() {
  //     if (!mq.matches) {
  //       resetTocPosition();
  //       return;
  //     }

  //     const offset = getScrollOffset(root);
  //     const sidebarRect = sidebar.getBoundingClientRect();
  //     const bodyRect = body.getBoundingClientRect();
  //     const tocHeight = toc.offsetHeight;

  //     if (bodyRect.top > offset) {
  //       resetTocPosition();
  //       return;
  //     }

  //     if (bodyRect.bottom <= offset + tocHeight) {
  //       toc.classList.remove('is-fixed');
  //       toc.style.position = 'absolute';
  //       toc.style.top = 'auto';
  //       toc.style.bottom = '0';
  //       toc.style.left = '0';
  //       toc.style.width = '100%';
  //       toc.style.maxHeight = '';
  //       if (placeholder) {
  //         placeholder.style.display = 'none';
  //       }
  //       return;
  //     }

  //     if (!placeholder) {
  //       placeholder = document.createElement('div');
  //       placeholder.className = 'eaa__toc-placeholder';
  //       sidebar.insertBefore(placeholder, toc);
  //     }

  //     placeholder.style.display = 'block';
  //     placeholder.style.height = `${tocHeight}px`;

  //     toc.classList.add('is-fixed');
  //     toc.style.position = 'fixed';
  //     toc.style.top = `${offset}px`;
  //     toc.style.left = `${sidebarRect.left}px`;
  //     toc.style.width = `${sidebarRect.width}px`;
  //     toc.style.bottom = 'auto';
  //     toc.style.maxHeight = `calc(100vh - ${offset}px - 24px)`;
  //   }

  //   const onUpdate = () => window.requestAnimationFrame(updateTocPosition);

  //   window.addEventListener('scroll', onUpdate, { passive: true });
  //   window.addEventListener('resize', onUpdate);
  //   if (mq.addEventListener) {
  //     mq.addEventListener('change', onUpdate);
  //   } else {
  //     mq.addListener(onUpdate);
  //   }

  //   onUpdate();
  // }

  function initScrollSpy(root) {
    const links = Array.from(root.querySelectorAll('[data-eaa-toc-link]'));
    if (!links.length) return;

    const headings = links
      .map((link) => document.querySelector(link.getAttribute('href')))
      .filter(Boolean);

    if (!('IntersectionObserver' in window)) {
      setActiveLink(root, links[0]);
      return;
    }

    const offset = getScrollOffset(root);
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (!visible.length) return;
        const topEntry = visible.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        const activeLink = links.find((link) => link.getAttribute('href') === `#${topEntry.target.id}`);
        if (activeLink) setActiveLink(root, activeLink);
      },
      { rootMargin: `-${offset}px 0px -60% 0px`, threshold: 0 }
    );

    headings.forEach((heading) => observer.observe(heading));
    setActiveLink(root, links[0]);
  }

  function initSection(sectionEl) {
    const root = sectionEl.querySelector('[data-extended-article]');
    if (!root || root.dataset.eaaReady === 'true') return;
    root.dataset.eaaReady = 'true';
    buildToc(root);
    initFixedSidebarToc(root);

    const content = root.querySelector('[data-eaa-content]');
    if (window.location.hash && content) {
      const target = document.querySelector(window.location.hash);
      if (target && content.contains(target)) {
        window.requestAnimationFrame(() => {
          scrollToHeading(target, root);
        });
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.extended-article-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('extended-article-section')) {
      const root = event.target.querySelector('[data-extended-article]');
      if (root) root.dataset.eaaReady = 'false';
      initSection(event.target);
    }
  });
})();
